export const getIp = async () => {
  const response = await fetch(
    'https://ipgeolocation.abstractapi.com/v1/?api_key=55c85ee246c64f8fb0519c3aea1bb36f',
  )
  return await response.json()
}
